module.exports = __webpack_public_path__ + "img/客户关系管理.61f3dded.jpg";